import classNames from 'clsx';
import React from 'react';
import { Field } from 'react-final-form';

import Translation from '@swf/components/Translation/Translation';
import { EulaType } from '@swf/core/enums';
import usePauseValidator from '@swf/core/hooks/usePauseValidator';
import useValidator from '@swf/core/hooks/useValidator';
import { required } from '@swf/core/utils/validators';
import { Checkbox, InfoPrompt } from '@swf/first';

import styles from '../RegulatoryCheckboxes.scss';
import useLabel from '../hooks/useLabel';

import {
  TXTCLI_What_does_this_meanX,
  TXTWCL_Checking_this_box_means_you_ac_ELL
} from './FirstCheckbox.messages.json';

interface Props {
  eulaType: EulaType;
  variant?: 'first' | 'rmf' | 'stars';
  isRequired?: boolean;
  onEulaLinkClick?: () => void;
  onPrivacyLinkClick?: () => void;
}

const FirstCheckbox: React.FC<Props> = ({
  eulaType,
  variant = 'first',
  isRequired = true,
  onEulaLinkClick,
  onPrivacyLinkClick
}) => {
  usePauseValidator();
  const [validator] = useValidator(required());
  const getLabel = useLabel(onEulaLinkClick, onPrivacyLinkClick);

  return (
    <Field name={eulaType} type="checkbox" validate={isRequired ? validator : undefined}>
      {({ input: { onChange, checked }, meta }) => (
        <div
          className={classNames(styles.wrapper, {
            [styles.eligible]: eulaType === EulaType.IAmEligibleToPlay
          })}
        >
          <Checkbox
            meta={meta}
            name={eulaType}
            checked={checked}
            onChange={onChange}
            className={styles.cashier}
            label={getLabel(variant, eulaType)}
          />
          {eulaType === EulaType.IAmEligibleToPlay && (
            <InfoPrompt
              title={{ translation: TXTCLI_What_does_this_meanX }}
              content={<Translation tagName="p" {...TXTWCL_Checking_this_box_means_you_ac_ELL} />}
            />
          )}
        </div>
      )}
    </Field>
  );
};

export default FirstCheckbox;
